import { render, staticRenderFns } from "./TaskCompleted.vue?vue&type=template&id=6878d02b&"
import script from "./TaskCompleted.vue?vue&type=script&lang=ts&"
export * from "./TaskCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCompleted.vue?vue&type=style&index=0&id=6878d02b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports